import { Dealer, FormTypes } from '../../gql/graphql';

export const isLongForm = (dealer: Dealer) => {
  return dealer?.formType === FormTypes.Long || dealer?.formType === FormTypes.LongV2;
};
